/**
 * Best-guess UI language for a visitor who has not told us yet.
 *
 * Order: an explicit earlier choice (localStorage) → the browser's language
 * list, matched on the base tag (pt-BR → pt) → fallback. No component imports,
 * so i18n/index.ts can use it at boot.
 */
export const SUPPORTED_LANGUAGE_CODES = [
  'de', 'en', 'fr', 'es', 'it', 'pt', 'nl', 'sv', 'pl', 'cs', 'tr', 'uk', 'ja', 'ko',
] as const;

const SUPPORTED = new Set<string>(SUPPORTED_LANGUAGE_CODES);

export function detectLanguage(fallback = 'de'): string {
  try {
    const stored = localStorage.getItem('language');
    if (stored && SUPPORTED.has(stored)) return stored;
  } catch { /* storage unavailable */ }

  if (typeof navigator !== 'undefined') {
    const candidates = navigator.languages && navigator.languages.length
      ? navigator.languages
      : [navigator.language];
    for (const tag of candidates) {
      if (!tag) continue;
      const base = tag.toLowerCase().split('-')[0];
      if (SUPPORTED.has(base)) return base;
    }
  }
  return fallback;
}
